/**
 * @author Transoft.ltda on 18/05/2016.
 */

(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('routeCtrl', routeCtrl)
        .controller('newRouteCtrl', newRouteCtrl)
        .controller('editRouteCtrl', editRouteCtrl)
        .controller('viewDetailRouteCtrl', viewDetailRouteCtrl)
        .controller('deleteRouteCtrl', deleteRouteCtrl);

    routeCtrl.$inject = ['linkService','routes'];
    newRouteCtrl.$inject = ['$rootScope', '$scope', 'stretchAssistantService','routeService','linkService', 'segmentService'];
    editRouteCtrl.$inject = ['$scope', '$stateParams', 'routeService','routeObj'];
    viewDetailRouteCtrl.$inject = ['routeObj'];
    deleteRouteCtrl.$inject = ['routeService', '$uibModalInstance', '$stateParams'];

    function routeCtrl(linkService,routes) {
        var vm = this;
        vm.linkService = linkService;
        vm.routes = (routes.data._embedded) ? routes.data._embedded.routes : [];
        vm.pages = routes.data.page;

        vm.sumDistance = function(stretchRoutes){
            var total = 0;
            for (var i=0; i<stretchRoutes.length;i++){
                total = total + stretchRoutes[i]._embedded.segment.distance;
            }
            return total;
        }
    };

    function newRouteCtrl($rootScope, $scope, stretchAssistantService,routeService,linkService,segmentService) {
        var vm = this;
        vm.stretchRoutes = "";
        vm.action = "new";

        vm.routeObject = {
            'segments': [],
            'stretchRoutes': [],
            'name': '',
            'initials': '',
            'deleted': false
        };

        $scope.routeObjectA = {
            'segments': [],
            'stretchRoutes': [],
            'name': '',
            'initials': '',
            'deleted': false
        };

        vm.segmentAdd = function(){
            var segment = 'Segment '+ ($scope.routeObjectA.stretchRoutes.length+1);
            if ($scope.routeObjectA.stretchRoutes.length===0){
                $scope.routeObjectA.stretchRoutes.push({
                    "originId":0,
                    "destinyId":0,
                    "orden":1,
                    "nameSegment":segment,
                    "nameOrigin":'',
                    "iataOrigin":'',
                    "nameDestiny":'',
                    "iataDestiny":'',
                    "name": ''
                });
            }else{
                if($scope.routeObjectA.stretchRoutes[$scope.routeObjectA.stretchRoutes.length-1].destinyId !==0){
                    $scope.routeObjectA.stretchRoutes.push({
                        "originId":$scope.routeObjectA.stretchRoutes[$scope.routeObjectA.stretchRoutes.length-1].destinyId,
                        "destinyId":0,
                        "orden":$scope.routeObjectA.stretchRoutes.length+1,
                        "nameSegment":segment,
                        "nameOrigin":$scope.routeObjectA.stretchRoutes[$scope.routeObjectA.stretchRoutes.length-1].nameDestiny,
                        "nameDestiny":'',
                        "name": ''
                    });
                }else{
                    $(".validField").each(function(index,val){
                        if(!$("#"+val.id).parent().find("span").hasClass("has-error") && val.value===""){
                            $("#"+val.id).parent().append('<span class="help-block has-error error-msg" style="color:#b94a48 !important">Este campo es requerido</span>');
                        }
                    });
                }
            }
        }

        vm.updateDataPoint = function(name, flag, index){
            var object = $rootScope.segmentAssistantTmp;
            name = name===''?'-':name;
            if(flag){
                if($rootScope.segmentAssistantTmp._embedded) {
                    stretchAssistantService.searchDestinyIata(linkService.getLinkId($rootScope.segmentAssistantTmp._embedded.airports[0]._links.self.href),
                        $rootScope.segmentAssistantTmp._embedded.airports[1].iata)
                        .then(function (res) {
                            if (res.data._embedded.stretchAssistants.length > 0) {
                                addObject(name, flag, index, object);
                                vm.stretchRoutes = 'add';
                            } else {
                                resetObjJsonOrigen(index)
                            }
                        }, function (res) {

                        });
                }
            }else {
                if($rootScope.segmentAssistantTmp._embedded) {
                    stretchAssistantService.searchIata($rootScope.segmentAssistantTmp._embedded.airports[0].iata)
                        .then(function (res) {
                            if (res.data._embedded.stretchAssistants.length > 0) {
                                addObject(name, flag, index, object);
                            } else {
                                resetObjJson(index);
                            }
                        }, function (res) {

                        });
                }else{
                    resetObjJson(index);
                }
            }

        }

        vm.onSegmentRoute = function (segmentRoute, isOriginDestiny, index) {
            if(segmentRoute != null) {
                var name = name===''?'-':name;
                if(isOriginDestiny){
                    if(segmentRoute._embedded) {
                        stretchAssistantService.searchDestinyIata(linkService.getLinkId(segmentRoute._embedded.airports[0]._links.self.href),
                            segmentRoute._embedded.airports[1].iata)
                            .then(function (res) {
                                if (res.data._embedded.stretchAssistants.length > 0) {
                                    vm.addSegmentRouteObject(name, isOriginDestiny, index, segmentRoute);
                                    vm.stretchRoutes = 'add';
                                } else {
                                    resetObjJsonOrigen(index);
                                }
                            });
                    }
                }else {
                    if(segmentRoute._embedded) {
                        stretchAssistantService.searchIata(segmentRoute._embedded.airports[0].iata)
                            .then(function (res) {
                                if (res.data._embedded.stretchAssistants.length > 0) {
                                    vm.addSegmentRouteObject(name, isOriginDestiny, index, segmentRoute);
                                } else {
                                    resetObjJson(index);
                                }
                            }, function (res) {

                            });
                    }else{
                        resetObjJson(index);
                    }
                }
            }else{
                if(isOriginDestiny) {
                    $scope.routeObjectA.stretchRoutes[index].nameDestiny = null;
                }else{
                    $scope.routeObjectA.stretchRoutes[index].nameOrigin = null;
                }
            }
        }

        vm.addSegmentRouteObject = function (name, isOriginDestiny, index, segmentRoute) {
            if(segmentRoute !== undefined){
                if(linkService.getLinkId(segmentRoute._embedded.airports[0]._links.self.href)!==0){
                    $scope.routeObjectA.stretchRoutes[index].originId = linkService.getLinkId(segmentRoute._embedded.airports[0]._links.self.href);
                    $scope.routeObjectA.stretchRoutes[index].iataOrigin = segmentRoute._embedded.airports[0].iata;
                    $scope.routeObjectA.stretchRoutes[index].nameOrigin = segmentRoute._embedded.airports[0].iata;
                    if(isOriginDestiny){
                        $scope.routeObjectA.stretchRoutes[index].destinyId = linkService.getLinkId(segmentRoute._embedded.airports[1]._links.self.href);
                        $scope.routeObjectA.stretchRoutes[index].iataDestiny = segmentRoute._embedded.airports[1].iata;
                        $scope.routeObjectA.stretchRoutes[index].nameDestiny = segmentRoute._embedded.airports[1].iata;
                        $scope.routeObjectA.stretchRoutes[index].name = segmentRoute._embedded.airports[0].iata +' - ' +segmentRoute._embedded.airports[1].iata;
                        resetObjectJson(isOriginDestiny);
                    }
                }
            }else{
                resetObjJson(index);
            }
        }

        vm.updateSegmentRoute = function () {

        }

        function addObject(name, flag, index,object){
            if(object!==undefined){
                if(linkService.getLinkId(object._embedded.airports[0]._links.self.href)!==0){
                    $scope.routeObjectA.stretchRoutes[index].originId = linkService.getLinkId(object._embedded.airports[0]._links.self.href);
                    $scope.routeObjectA.stretchRoutes[index].iataOrigin = $rootScope.segmentAssistantTmp._embedded.airports[0].iata;
                    $scope.routeObjectA.stretchRoutes[index].nameOrigin = $rootScope.segmentAssistantTmp._embedded.airports[0].iata;
                    if(flag){
                        $scope.routeObjectA.stretchRoutes[index].destinyId = linkService.getLinkId(object._embedded.airports[1]._links.self.href);
                        $scope.routeObjectA.stretchRoutes[index].iataDestiny = $rootScope.segmentAssistantTmp._embedded.airports[1].iata;
                        $scope.routeObjectA.stretchRoutes[index].nameDestiny = $rootScope.segmentAssistantTmp._embedded.airports[1].iata;
                        $scope.routeObjectA.stretchRoutes[index].name = $rootScope.segmentAssistantTmp._embedded.airports[0].iata +' - '
                            +$rootScope.segmentAssistantTmp._embedded.airports[1].iata;
                        resetObjectJson(flag);
                    }
                }
            }else{
                resetObjJson(index);
            }
        }

        vm.deleteSegment = function(){
            $scope.routeObjectA.stretchRoutes.pop();
            resetObjectJson(true);
        }

        function resetObjJsonOrigen(index){
            $scope.routeObjectA.stretchRoutes[index].destinyId = 0;
            $scope.routeObjectA.stretchRoutes[index].iataDestiny = '';
            $scope.routeObjectA.stretchRoutes[index].nameDestiny = '';
            $scope.routeObjectA.stretchRoutes[index].name = '';
            $scope.routeObjectA.stretchRoutes[index].initials = '';
        }

        function resetObjJson(index){
            vm.stretchRoutes = '';
            $scope.routeObjectA.stretchRoutes[index].originId = 0;
            $scope.routeObjectA.stretchRoutes[index].iataOrigin = '';
            $scope.routeObjectA.stretchRoutes[index].nameOrigin = '';
            $scope.routeObjectA.stretchRoutes[index].destinyId = 0;
            $scope.routeObjectA.stretchRoutes[index].iataDestiny = '';
            $scope.routeObjectA.stretchRoutes[index].nameDestiny = '';
            $scope.routeObjectA.stretchRoutes[index].name = '';
            $scope.routeObjectA.stretchRoutes[index].initials = '';
            if(index===0){
                vm.routeObject.segments = [];
                vm.routeObject.stretchRoutes = [];
                vm.routeObject.name = '';
                vm.routeObject.initials = '';
                vm.routeObject.deleted = false;
            }else{

            }
        }
        function resetObjectJson(flag){
            vm.routeObject.stretchRoutes = [];
            vm.routeObject.name = '';
            vm.routeObject.initials = '';
            var arrayObject = [];
            var arrayObjectInitials = [];
            angular.forEach($scope.routeObjectA.stretchRoutes,function(val){
                if(val.destinyId!==0){
                    vm.routeObject.stretchRoutes.push(val);
                    if(vm.routeObject.name!==''){
                        arrayObject = vm.routeObject.name.split('-');
                        arrayObjectInitials = vm.routeObject.initials.split('-');
                        vm.routeObject.name = vm.routeObject.name.replace(arrayObject[arrayObject.length-1]+""," "+val.name+"");
                        vm.routeObject.initials = vm.routeObject.initials+" - "+val.iataDestiny;
                    }else{
                        vm.routeObject.name = val.name;
                        vm.routeObject.initials = val.iataOrigin +' - '+val.iataDestiny;
                    }
                }
            });
            if(flag){
                restObjectSegment();
            }
        }

        function restObjectSegment(){
            vm.routeObject.segments=[];
            angular.forEach(vm.routeObject.stretchRoutes,function(val, index){
                for (var i = index; i < vm.routeObject.stretchRoutes.length; i++){
                    if(existObject(val.originId,vm.routeObject.stretchRoutes[i].destinyId) && (val.originId !== vm.routeObject.stretchRoutes[i].destinyId)){
                        vm.routeObject.segments.push(
                            {
                                "originId": val.originId,
                                "destinyId": vm.routeObject.stretchRoutes[i].destinyId,
                                "name": val.nameOrigin + ' - ' + vm.routeObject.stretchRoutes[i].nameDestiny,
                                "initials": val.iataOrigin + ' - ' + vm.routeObject.stretchRoutes[i].iataDestiny,
                                "distance": ''
                            });
                    }
                }
            });

            angular.forEach(vm.routeObject.segments,function(segment){
                segmentService.getSegmentByOriginDestiny(segment.originId, segment.destinyId, true)
                    .then(function (response) {
                        if(response.status === 500){
                            segment.distance = 0;
                        }else{
                            segment.distance = response.data.distance;
                        }
                    });
            });
        }

        function existObject(origin,destiny){
            var exist = true;
            angular.forEach(vm.routeObject.segments,function(val){
                if(origin == val.originId && destiny==val.destinyId){
                    exist = false;
                }
            });
            return exist;
        }

        vm.saveRoute = function(isValid, routeAux){
            if(isValid && routeAux.stretchRoutes.length>0){
                routeService.saveRoute(vm.routeObject);
            }
        }
    }

    function editRouteCtrl($scope, $stateParams,routeService,routeObj) {
        var vm = this;
        vm.action = 'edit';
        vm.route = {};
        vm.stretchRoutes = 'add';

        vm.routeObject = {
            'segments': [],
            'stretchRoutes': [],
            'name': '',
            'initials': '',
            'deleted': false
        };

        $scope.routeObjectA = {
            'segments': [],
            'stretchRoutes': [],
            'name': '',
            'initials': '',
            'deleted': false
        };

        getRoute();
        vm.old = angular.copy(vm.routeObject);
        vm.buttonSave = true;

        function getRoute(){
            if (routeObj.data !== undefined){
                vm.route = routeObj.data;
                vm.routeObject.name = routeObj.data.name;
                vm.routeObject.initials = routeObj.data.initials;
                vm.routeObject.deleted = routeObj.data.deleted;
                angular.forEach(vm.route._embedded.stretchRoutes,function(val,index){
                    vm.routeObject.stretchRoutes.push({
                        "originId":val.originId,
                        "destinyId":val.destinyId,
                        "orden":val.orden,
                        "name": val._embedded.segment.name
                    })
                    $scope.routeObjectA.stretchRoutes.push({
                        "originId":val.originId,
                        "destinyId":val.destinyId,
                        "orden":val.orden,
                        "nameSegment": "Segment " + (index+1),
                        "nameOrigin":val._embedded.segment.name.split("-")[0],
                        "nameDestiny":val._embedded.segment.name.split("-")[1],
                        "name": val._embedded.segment.name
                    });
                });
                angular.forEach(vm.route._embedded.segmentRoutes,function(val,index){
                    vm.routeObject.segments.push({
                        "originId":val.originId,
                        "destinyId":val.destinyId,
                        "name": val._embedded.segment.name,
                        "initials":val._embedded.segment.initials,
                        "distance":val._embedded.segment.distance
                    });
                });
                $scope.stretchRoutes = "add";
            }
        }

        vm.saveRoute = function(isValid, routeAux){
            if(isValid && routeAux.stretchRoutes.length>0){
                routeService.updateRoute($stateParams.id,routeAux);
            }
        }

        vm.change = function(){
            var flag = true;
            for(var i=0; i<vm.routeObject.segments.length; i++) {
                if(vm.routeObject.segments[i].distance!==vm.old.segments[i].distance){
                    flag = false;
                    break;
                }
            }
            if(flag){
                vm.buttonSave = true;
            }else{
                vm.buttonSave = false;
            }
        }
    }

    function viewDetailRouteCtrl(routeObj) {

        var vm = this;
        vm.route = {};
        vm.name = '';

        if (routeObj.data._embedded !== undefined){
            vm.name = routeObj.data.name;
            vm.route = routeObj.data._embedded;
        }
    }

    function deleteRouteCtrl(routeService, $uibModalInstance, $stateParams){
        var vm = this;
        vm.deleteRoute = function(){
            routeService.deleteRoute($stateParams.id)
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function convertDistanceToNumber(segments) {
    }
})();
